import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useComplaintModal } from "../context/ComplaintModalContext";
import NotificationBell from "./NotificationBell";
import { donoNaoContar, setDonoOptOut } from "../services/api";

export default function Header() {
  const { user, logout, isAdmin } = useAuth();
  const { openComplaint } = useComplaintModal();
  const navigate = useNavigate();
  const local = useLocation();
  const [menu, setMenu] = useState(false);

  const itemCls = "block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100";
  // Vale o TIPO da sessão, não a permissão da conta. O admin que impersona uma empresa fica com tipo=1 mas
  // segue com ehAdmin=true — e é justamente ele que precisa ver a tela como ela vê, que é para isso que a
  // impersonação existe. Amarrar em "!isAdmin" fazia o menu da empresa nunca aparecer para quem mais o testa.
  const ehEmpresa = user?.tipo === 1;

  return (
    <header className="sticky top-0 z-50 bg-brand text-white shadow">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between gap-3 px-4 md:h-20 md:px-6">
        <Link to="/" className="flex items-center gap-2.5 font-bold text-xl md:text-2xl shrink-0">
          <img src="/icone-eairh-branco.svg" alt="eaiRH" className="h-11 w-11 md:h-14 md:w-14" />
          <span>eai<span className="text-orange-400">RH?</span></span>
        </Link>

        {/* A barra falava só com visitante e candidato: "Por que registrar?" convida a reclamar, e quem está
            logado como EMPRESA não vai reclamar de si mesma. Aqui ela passa a levar ao trabalho do dia — painel,
            vagas, publicar, buscar candidato — em vez de páginas institucionais que ela já leu antes de entrar. */}
        <nav className="hidden items-center gap-5 lg:flex">
          {ehEmpresa ? (
            <>
              <Link to="/painel" className="text-white/85 hover:text-white">Painel</Link>
              <Link to="/vagas" className="text-white/85 hover:text-white">Minhas vagas</Link>
              <Link to="/vagas/nova" className="text-white/85 hover:text-white">Publicar vaga</Link>
              {/* 18/10/2026 (Nelson): chamar candidato e acompanhar as entrevistas fica na barra, junto do dia a dia. */}
              <Link to="/entrevistas" className="text-white/85 hover:text-white">Entrevistas</Link>
              {/* O cadastro da empresa estava só dentro do menu da conta, com nome de dado pessoal — a empresa
                  não achava. É o que ela edita antes de publicar a primeira vaga: fica na barra. */}
              <Link to="/conta" className="text-white/85 hover:text-white">Dados da empresa</Link>
            </>
          ) : (
            <>
              <Link to="/" className="text-white/85 hover:text-white">Início</Link>
              <Link to="/empresas" className="text-white/85 hover:text-white">Empresas</Link>
              <Link to="/vagas" className="text-white/85 hover:text-white">Vagas</Link>
              <Link to="/indicadores" className="text-white/85 hover:text-white">Indicadores</Link>
              <Link to="/selo" className="text-white/85 hover:text-white">🏅 Selo</Link>
              <Link to="/como-funciona" className="text-white/85 hover:text-white">Sobre</Link>
              <Link to="/por-que" className="text-white/85 hover:text-white">Por que registrar?</Link>
            </>
          )}
        </nav>

        <div className="flex items-center gap-2 md:gap-3">
          {user ? (
            <>
              <NotificationBell />
              <div className="relative">
                <button onClick={() => setMenu((o) => !o)} aria-haspopup="true" aria-expanded={menu} aria-label="Menu da conta"
                  className="flex items-center gap-1 text-sm text-white/90 hover:text-white">
                  <span className="hidden sm:inline">Olá, {user.nome.split(" ")[0]}</span>
                  <span className="sm:hidden">Conta</span>
                  {user.tipo === 1 && <span className="text-[10px] bg-white/20 rounded px-1.5 py-0.5">Empresa</span>}
                  {user.tipo === 3 && <span className="text-[10px] bg-white/20 rounded px-1.5 py-0.5">Parceiro</span>}
                  <span className="text-xs">▾</span>
                </button>
                {menu && (
                  <>
                    <div className="fixed inset-0 z-40" onClick={() => setMenu(false)} />
                    <div className="absolute right-0 mt-2 w-56 rounded-xl bg-white text-gray-700 shadow-xl ring-1 ring-black/5 z-50 py-1">
                      {/* Para empresa este item JÁ está na barra ("Dados da empresa"), então aqui ele só aparece
                          no celular, onde a barra não existe. Repetir o mesmo link a dois cliques de distância
                          faz a pessoa duvidar se são a mesma coisa. */}
                      <Link to="/conta" className={ehEmpresa ? `${itemCls} lg:hidden` : itemCls} onClick={() => setMenu(false)}>
                        {ehEmpresa ? "Dados da empresa" : "Minha conta"}
                      </Link>
                      {isAdmin && <Link to="/admin" className={`${itemCls} font-semibold text-primary`} onClick={() => setMenu(false)}>🛠️ Painel admin</Link>}
                      {isAdmin && (
                        <button onClick={() => { setDonoOptOut(!donoNaoContar()); setMenu(false); }}
                          className={`${itemCls} w-full text-left`}>
                          {donoNaoContar() ? "🔊 Voltar a contar minhas visitas" : "🔇 Não contar minhas visitas"}
                        </button>
                      )}
                      {/* Mesma régua do desktop: no celular a empresa também vê o menu do trabalho dela. */}
                      {ehEmpresa ? (
                        <>
                          <Link to="/painel" className={`${itemCls} lg:hidden`} onClick={() => setMenu(false)}>Painel</Link>
                          <Link to="/vagas" className={`${itemCls} lg:hidden`} onClick={() => setMenu(false)}>Minhas vagas</Link>
                          <Link to="/vagas/nova" className={`${itemCls} lg:hidden`} onClick={() => setMenu(false)}>Publicar vaga</Link>
                          <Link to="/entrevistas" className={`${itemCls} lg:hidden`} onClick={() => setMenu(false)}>Entrevistas</Link>
                        </>
                      ) : (
                        <>
                          <Link to="/" className={`${itemCls} lg:hidden`} onClick={() => setMenu(false)}>Início</Link>
                          <Link to="/empresas" className={`${itemCls} lg:hidden`} onClick={() => setMenu(false)}>Empresas</Link>
                          <Link to="/vagas" className={`${itemCls} lg:hidden`} onClick={() => setMenu(false)}>Vagas</Link>
                          <Link to="/indicadores" className={`${itemCls} lg:hidden`} onClick={() => setMenu(false)}>Indicadores</Link>
                          <Link to="/selo" className={`${itemCls} lg:hidden`} onClick={() => setMenu(false)}>🏅 Selo</Link>
                          <Link to="/por-que" className={`${itemCls} lg:hidden`} onClick={() => setMenu(false)}>Por que registrar?</Link>
                        </>
                      )}
                      {user.tipo === 3 && <Link to="/parceiro" className={`${itemCls} font-semibold text-primary`} onClick={() => setMenu(false)}>🎓 Painel do parceiro</Link>}
                      {user.tipo === 0 && <Link to="/oportunidades" className={itemCls} onClick={() => setMenu(false)}>✨ Oportunidades</Link>}
                      {user.tipo === 0 && <Link to="/capacitacao" className={itemCls} onClick={() => setMenu(false)}>🎓 Capacitação</Link>}
                      {user.tipo === 0 && <Link to="/entrevistas" className={itemCls} onClick={() => setMenu(false)}>📅 Minhas entrevistas</Link>}
                      {user.tipo === 0 && <Link to="/minhas-reclamacoes" className={itemCls} onClick={() => setMenu(false)}>Meus relatos</Link>}
                      {user.tipo === 0 && <Link to="/curriculo" className={itemCls} onClick={() => setMenu(false)}>Meu currículo</Link>}
                      {/* O modal do handoff manda a pessoa a "Minhas candidaturas", e o menu não tinha esse lugar: ela só
                          existia como aba escondida em /vagas (Bruno, 14/09/2026, rodou /, /curriculo e /vagas procurando). */}
                      {user.tipo === 0 && <Link to="/vagas?view=minhas" className={itemCls} onClick={() => setMenu(false)}>Minhas candidaturas</Link>}
                      <Link to="/como-funciona" className={`${itemCls} lg:hidden`} onClick={() => setMenu(false)}>Como funciona</Link>
                      <hr className="my-1 border-gray-100" />
                      <button onClick={() => { setMenu(false); logout(); navigate("/"); }}
                        className={`${itemCls} w-full text-left text-red-600`}>Sair</button>
                    </div>
                  </>
                )}
              </div>
            </>
          ) : (
            <>
              {/* O "Entrar" do topo levava sempre para a home depois do login. Em 10/09 alguém veio do LinkedIn
                  para uma vaga da Gateware, clicou aqui em 0s (o botão da vaga fica abaixo da descrição), passou
                  12s no login e foi embora para /vagas — sem caminho de volta para a vaga que queria. */}
              <Link to={["/", "/entrar"].includes(local.pathname) ? "/entrar"
                  : `/entrar?redirect=${encodeURIComponent(local.pathname + local.search)}`}
                className="text-sm text-white/85 hover:text-white">Entrar</Link>
              {/* Hambúrguer só em telas &lt; lg: dá acesso aos links de navegação para quem não está logado */}
              <div className="relative lg:hidden">
                <button onClick={() => setMenu((o) => !o)} aria-label="Abrir menu" aria-expanded={menu}
                  className="flex items-center p-1 text-white/90 hover:text-white">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
                    <line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="18" x2="21" y2="18" />
                  </svg>
                </button>
                {menu && (
                  <>
                    <div className="fixed inset-0 z-40" onClick={() => setMenu(false)} />
                    <div className="absolute right-0 mt-2 w-56 rounded-xl bg-white text-gray-700 shadow-xl ring-1 ring-black/5 z-50 py-1">
                      <Link to="/" className={itemCls} onClick={() => setMenu(false)}>Início</Link>
                      <Link to="/empresas" className={itemCls} onClick={() => setMenu(false)}>Empresas</Link>
                      <Link to="/vagas" className={itemCls} onClick={() => setMenu(false)}>Vagas</Link>
                      <Link to="/indicadores" className={itemCls} onClick={() => setMenu(false)}>Indicadores</Link>
                      <Link to="/selo" className={itemCls} onClick={() => setMenu(false)}>🏅 Selo</Link>
                      <Link to="/como-funciona" className={itemCls} onClick={() => setMenu(false)}>Sobre</Link>
                      <Link to="/por-que" className={itemCls} onClick={() => setMenu(false)}>Por que registrar?</Link>
                    </div>
                  </>
                )}
              </div>
            </>
          )}
          {user?.tipo !== 1 && (
            <button type="button" onClick={() => openComplaint()}
              className="inline-flex items-center rounded-xl bg-orange-600 px-3 py-2 text-sm font-semibold text-white hover:bg-orange-700 md:px-4">
              Fazer relato
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
